import { useNavigate } from "react-router-dom";
import React from "react";
import { MoveLeft } from "lucide-react";
import styles from "../teams/components/TeamSettings.module.css";
import "../join-team/JoinWithCode.css";
import { useLoginPage } from "../login/useLoginPage";
import LoginCodeInput from "../authentication/components/LoginCodeInput";

// experience-backend has no demo-team endpoint yet; honest no-op so the
// login flow still works.
const ensureDemoTeamForUser = async (_userUid: string, _email: string) => {
  console.warn(
    "TeamDemoLogin: ensureDemoTeamForUser is not supported by experience-backend yet."
  );
};

const TeamDemoLogin = () => {
  const navigate = useNavigate();
  const {
    error,
    emailForMagic,
    isLoading,
    successMessage,
    showCodeInput,
    setEmailForMagic,
    sendMagicLink,
    handleCodeVerified,
    handleBackToEmail,
    isOnline,
    loadingStates,
  } = useLoginPage({
    afterFirebaseAuthBeforeLoginUser: async ({ userUid, email }) => {
      await ensureDemoTeamForUser(userUid, email);
    },
  });

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        boxSizing: "border-box",
      }}
    >
      <div className="settings-element-header">
        <MoveLeft
          onClick={() =>
            showCodeInput
              ? handleBackToEmail()
              : navigate("/app/demo-team/next")
          }
          className={styles["back-button"]}
          aria-label="Back"
        />
        <p className={`settings-element-title page-title`}>Log in to proceed</p>
        <div className={styles["team-settings-header-spacer"]} aria-hidden />
      </div>

      <div style={{ padding: "16px", flex: 1 }}>
        {showCodeInput ? (
          <LoginCodeInput
            email={emailForMagic}
            onCodeVerified={handleCodeVerified}
            onBack={handleBackToEmail}
            isLoading={isLoading}
            isOnline={isOnline}
            fullPage={false}
          />
        ) : (
          <>
            <p style={{ color: "#555", marginBottom: "16px", lineHeight: 1.5 }}>
              Log in with the email you use (or will use) for your account, then
              open the link above to complete your purchase.
            </p>

            {error ? (
              <div
                className="JoinWithCode-error"
                style={{ marginBottom: "12px" }}
              >
                {error}
              </div>
            ) : null}
            {successMessage ? (
              <div
                style={{
                  backgroundColor: "#efe",
                  color: "#3c3",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  marginBottom: "16px",
                  fontSize: "14px",
                }}
              >
                {successMessage}
              </div>
            ) : null}

            {loadingStates?.users ? (
              <p style={{ color: "#666", marginBottom: "16px" }}>
                Loading user data...
              </p>
            ) : (
              <>
                <input
                  type="email"
                  autoComplete="email"
                  className="JoinWithCode-input"
                  value={emailForMagic}
                  onChange={(e) => {
                    setEmailForMagic(e.target.value);
                  }}
                  placeholder="Email"
                />

                <button
                  type="button"
                  className="proceed-button"
                  onClick={() => void sendMagicLink()}
                  disabled={!emailForMagic.trim() || isLoading}
                >
                  {isLoading ? "Sending..." : "Log in"}
                </button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TeamDemoLogin;
